import styled from 'styled-components';
import theme from '../../../UI/theme';

export const TextMuted = styled.span`
    font-size: ${theme.fontSize.small};
    color: ${theme.colors.textGray};
`